import { render, staticRenderFns } from "./Leases.vue?vue&type=template&id=6f1aa714"
import script from "./Leases.vue?vue&type=script&lang=js"
export * from "./Leases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports